// File category + photo-subtype metadata for UI rendering.
import {
  ImageIcon, Layers3, Boxes, FileCode, FileText, Smile, ScanFace, Activity,
} from "lucide-react";

export const CATEGORY_META = {
  radiograph_2d: { label: "Radiograph", Icon: ImageIcon, color: "var(--pa-gold)" },
  clinical_photo: { label: "Clinical photo", Icon: Smile, color: "#FCD34D" },
  study_model: { label: "Study model", Icon: ScanFace, color: "#FDE68A" },
  dicom: { label: "DICOM", Icon: Layers3, color: "#7DD3FC" },
  scan_3d: { label: "3D Scan", Icon: Boxes, color: "#A78BFA" },
  exocad: { label: "exocad / Lab", Icon: FileCode, color: "#FDA4AF" },
  realguide_stl: { label: "Real Guide — STL", Icon: Activity, color: "#34D399" },
  realguide_dicom: { label: "Real Guide — DICOM", Icon: Activity, color: "#34D399" },
  realguide_report: { label: "Real Guide — Report", Icon: Activity, color: "#34D399" },
  report: { label: "Report (PDF)", Icon: FileText, color: "var(--pa-text-muted)" },
  other: { label: "File", Icon: FileText, color: "var(--pa-text-muted)" },
};

// The 11 clinician-selectable photo subtypes (matches PHOTO_SUBTYPES on backend).
// Empty string = "Auto-classify / radiograph" (don't tag as a clinical photo).
export const PHOTO_SUBTYPE_OPTIONS = [
  { value: "", label: "Auto / Radiograph" },
  { value: "full_face", label: "Full face" },
  { value: "profile_left", label: "Profile (left)" },
  { value: "profile_right", label: "Profile (right)" },
  { value: "retracted_anterior", label: "Retracted — anterior" },
  { value: "retracted_posterior", label: "Retracted — posterior" },
  { value: "smile_relaxed", label: "Smile (relaxed)" },
  { value: "smile_full", label: "Smile (full)" },
  { value: "occlusal_upper", label: "Occlusal — upper arch" },
  { value: "occlusal_lower", label: "Occlusal — lower arch" },
  { value: "study_model_mounted", label: "Mounted study model" },
  { value: "wax_up", label: "Diagnostic wax-up" },
  { value: "other_clinical", label: "Other clinical photo" },
];

export const PHOTO_SUBTYPE_LABEL = Object.fromEntries(
  PHOTO_SUBTYPE_OPTIONS.map((o) => [o.value, o.label]),
);

export function humanSize(n) {
  if (n == null) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export const ACCEPT_EXTENSIONS =
  ".jpg,.jpeg,.png,.webp,.dcm,.dicom,.stl,.ply,.obj,.zip,.dxd,.constructioninfo,.dentalcad,.pdf";

// Modules where the Real Guide upload slot is relevant.
export const REALGUIDE_MODULES = new Set(["implant-case-planner", "all-on-x-planner"]);
